var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { fetcher } from "@/api/schema/fetcher";
import { errorMessageAsString } from "@/utils/simple-error";
import { canUpgrade, findTemplate, getLatestVersion, getLatestVersionMap } from "./configTemplatesUtil";
const getFileSourceTemplates = fetcher.path("/api/file_source_templates").method("get").create();
export const useFileSourceTemplatesStore = defineStore("fileSourceTemplatesStore", {
    state: () => ({
        templates: [],
        fetched: false,
        error: null,
    }),
    getters: {
        latestTemplates: (state) => {
            // only expose latest instance by template_version for each template_id
            const latestVersions = getLatestVersionMap(state.templates);
            return state.templates.filter((i) => latestVersions[i.id] == (i.version || 0));
        },
        canUpgrade: (state) => {
            return (templateId, templateVersion) => canUpgrade(state.templates, templateId, templateVersion);
        },
        getTemplates: (state) => {
            return state.templates;
        },
        getTemplate: (state) => {
            return (templateId, templateVersion) => findTemplate(state.templates, templateId, templateVersion);
        },
        getLatestTemplate: (state) => {
            return (templateId) => getLatestVersion(state.templates, templateId);
        },
        hasTemplates: (state) => {
            return state.templates.length > 0;
        },
        loading: (state) => {
            return !state.fetched;
        },
    },
    actions: {
        handleInit(templates) {
            return __awaiter(this, void 0, void 0, function* () {
                this.templates = templates;
                this.fetched = true;
            });
        },
        handleError(err) {
            return __awaiter(this, void 0, void 0, function* () {
                this.fetched = true;
                this.error = errorMessageAsString(err);
            });
        },
        fetchTemplates() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data: templates } = yield getFileSourceTemplates({});
                    this.handleInit(templates);
                }
                catch (err) {
                    this.handleError(err);
                }
            });
        },
        ensureTemplates() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.fetched || this.error != null) {
                    yield this.fetchTemplates();
                }
            });
        },
    },
});
